import React, {
  useContext,
  useState,
} from "react";
// import SchedularDeleteMeetingContainer from "./SchedularDeleteMeetingContainer";
import {
  ApolloError,
  useMutation,
  useQuery,
} from "@apollo/client";
import {
  format,
  parseISO,
} from "date-fns";
// import { DELETE_MEETING } from "../../../api/mutation";
// import { UserContext } from "../../../providers/MainContext";
import ioniconvvideocamoutline1 from "../../assets/task/meeting-icon.svg";
import viewMeeting from "../../assets/task/eye-show-svgrepo-com.svg";
import { useAuth } from "../../context/AuthContext";
import { showError, showSuccess } from "../common/ToastNotification";
import SkeletonLoader from "../common/SkeletonLoader";
import { GET_MEETINGS } from "../../api/query";
import { useNavigate } from "react-router-dom";
import { DELETE_BULK_MEETINGS } from "../../api/mutation";
import DeleteMeeting from "./DeleteMeeting";
interface MeetingProps {
  currentDate: any;
  ioniconaaddoutline: any;
  ioniconttimeoutline: any;
  icon: any;
  icon1: any;
  ioniconttimeoutline1: any;
  userUUID: any;
  employeeUrl: any;
  agencyId: any;
  employeeId: any
}

const Meetings: React.FC<MeetingProps> = ({
  currentDate,
  ioniconaaddoutline,
  ioniconttimeoutline,
  icon,
  icon1,
  ioniconttimeoutline1,
  userUUID,
  employeeUrl,
  agencyId,
  employeeId
}) => {
  const now = new Date(); // current local system time

  const navigate = useNavigate();
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [deletedId, setDeletedId] = useState<any>(null);
  const { userInfo } = useAuth();
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 4; // 4 items per page
  const [totalPages, setTotalPages] = useState(1); // Total pages from API

  const startDate = format(currentDate, "yyyy-MM-dd'T'00:00:00'Z'");
  const endDate = format(currentDate, "yyyy-MM-dd'T'23:59:59'Z'");

  const {
    loading,
    error,
    data: meetingsData,
    refetch: meetingRefetch,
  } = useQuery(GET_MEETINGS, {
    variables: {
      start_date: startDate,
      end_date: endDate,
      // employee_uuid: userUUID,
      // page: currentPage,
      // page_size: 100,
      agency_id: Number(agencyId),
    },
    fetchPolicy: "no-cache",
    skip: !userUUID,
    // onCompleted: (meetingsData) => {
    //   // setTotalPages(
    //   //   meetingsData?.get_meetings?.pagination?.total_pages || 1
    //   // );
    // },
  });

  // const getMeetings = meetingsData?.get_meetings?.meetings;
  const getMeetings =
    meetingsData?.get_meetings?.meetings?.filter(
      (m: any) => !m.is_deleted
    ) || [];

  function handleDeletePopUp(id: any) {
    if (id) {
      setIsDeletePopupOpen(true);
      setDeletedId(id);
    }
  }

  const closeDeletePopup = () => {
    setIsDeletePopupOpen(false);
  };

  // Delete
  const [deleteMeeting, { loading: deleteloading }] = useMutation(DELETE_BULK_MEETINGS);

  function handleEditMeeting(id: any, startDate: any, endDate: any) {
    // navigate("/edit_meeting", {
    //   state: {
    //     meetingID: id,
    //     startMeetDate: startDate,
    //     endMeetDate: endDate
    //   }
    // })

    navigate("/meeting_detail", {
      state: {
        meetingID: id,
        startMeetDate: startDate,
        endMeetDate: endDate
      }
    })

    // history.push({
    //   pathname: "/edit_meeting",

    //   state: {
    //     addId: id,
    //     dateForStart: startDate,
    //     meetingData: getMeetings,
    //     meetingTime: time,
    //   },
    // });
  }

  // const sendDeleteMeetingEmail = async (meeting: any) => {
  //   const emailURL =
  //     process.env.NODE_ENV === "development"
  //       ? "https://testwizkind.yaahr.com/"
  //       : "https://caryfyprodapi.caryfy.ai/";

  //   const memberEmails = meeting?.members
  //     ?.filter((member: any) => member.employee_uuid !== userInfo.uuid)
  //     ?.map((member: any) => member.email_id);

  //   const formattedDate = format(
  //     parseISO(meeting.start_datetime),
  //     "MM-dd-yyyy, hh:mm a"
  //   );

  //   const emailPayload = {
  //     product_name: "Caryfy",
  //     to_email: memberEmails,
  //     subject: `Meeting Cancelled: ${meeting?.title}`,
  //     message: `<!DOCTYPE html>
  // <html lang="en">
  // <head>
  //     <meta charset="UTF-8">
  //     <meta name="viewport" content="width=device-width, initial-scale=1.0">
  //     <link href="https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap" rel="stylesheet">
  //     <style>
  //         body { font-family: "Manrope", sans-serif; background-color: #f6f8ff; margin: 0; padding: 0; }
  //         .email-container { width: 100%; max-width: 600px; background-color: #f6f8ff; margin: 20px auto; padding: 20px; border-radius: 8px; box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); }
  //         table { width: 100%; border-collapse: collapse; margin-top: 20px; }
  //         th, td { padding: 12px; font-size: 14px; text-align: left; border: 1px solid #eee; }
  //         th { background-color: #fff; color: #000; font-weight: bold; }
  //         td { background-color: #fff; color: #000; }
  //         .footer { font-size: 14px; color: #000; margin-top: 20px; }
  //     </style>
  // </head>
  // <body>
  //     <div class="email-container">
  //     <div class="email-header" style="width: 100%; display: flex;"> 
  //     <div style="width: 76%; text-align: left">  
  //     <h2>Cancelled Meeting Scheduled</h2>
  //     </div>
  //     <div style="width: 20%; text-align: right !important; display: flex; align-items: center; justify-content: flex-end !important;">
  //     <img style="object-fit: contain; width: 120px!important;" src="https://anandchaturvedi.com/wp-content/uploads/2025/03/carebravo.png" style="width:120px; height: auto" alt="">
  //     </div>
  //     </div> 
  //         <p>Dear <b>Team,</b></p>
  //         <p>This is to inform you that the following meeting has been cancelled:</p>
  //         <table>
  //             <tr><td colspan="2"><b>Meeting Details:</b></td></tr>
  //             <tr><th>Title</th><td>${meeting?.title}</td></tr>
  //             <tr><th>Date & Time</th><td>${formattedDate}</td></tr>
  //             <tr><th>Duration</th><td>${meeting?.meeting_hours} hours and ${meeting?.meeting_minutes
  //       } minutes</td></tr>
  //         </table>
  //         <p class="footer">If you have any questions, please contact the meeting organizer.</p>
  //         <p class="footer">Best regards,</p>
  //         <p class="footer"><b>${userInfo?.last_name ? userInfo?.last_name : ""
  //       } ${userInfo?.middle_name ? userInfo?.middle_name : ""} ${userInfo?.first_name ? userInfo?.first_name : ""
  //       }</b></p>
  //     </div>
  // </body>
  // </html>`,
  //     is_html: true,
  //   };

  //   try {
  //     const emailResponse = await fetch(
  //       `${emailURL}caryfy-notification/send-email/`,
  //       {
  //         method: "POST",
  //         headers: { "Content-Type": "application/json" },
  //         body: JSON.stringify(emailPayload),
  //       }
  //     );

  //     if (emailResponse.ok) {
  //       showSuccess("Cancellation email sent successfully");
  //     } else {
  //       showError("Failed to send cancellation email");
  //     }
  //   } catch (error) {
  //     showError("Failed to send cancellation email");
  //   }
  // };

  const deleteMeetingFunction = (formData: any) => {
    // Find the meeting that's being deleted
    const meetingToDelete = getMeetings?.find(
      (meeting: any) => meeting.id === Number(deletedId)
    );

    return deleteMeeting({
      variables: {
        deleted_by: Number(employeeId),
        meeting_ids: [Number(deletedId)],
      },
    })
      .then((response: any) => {
        const { message, status_code } = response.data.delete_bulk_meetings;

        setDeletedId(null);
        setIsDeletePopupOpen(false);
        if (status_code == 200) {
          showSuccess(message);

          // Only send cancellation email if meeting is in the future
          if (meetingToDelete) {
            const meetingTime = new Date(meetingToDelete.start_date);
            const now = new Date();

            // Send email only if meeting is in the future
            // if (meetingTime > now) {
            //   sendDeleteMeetingEmail(meetingToDelete);
            // }
          }

          meetingRefetch({
            variables: {
              start_date: startDate,
              end_date: endDate,
              agency_id: Number(agencyId)
              // employee_uuid: userUUID,
              // page: currentPage,
              // page_size: pageSize,
            },
          });
          return true;
        }
      })
      .catch((error: any) => {
        if (error instanceof ApolloError) {
          showError(error.message);
          return false;
        } else {
          showError(error);
          return false;
        }
      });
  };

  // const handlePageChange = (pageNumber: any) => {
  //   setCurrentPage(pageNumber);
  //   // refetchTask(); // Refetch data for the new page
  // };

  // const currentTime = new Date(); // Get the current time



  function handleAddMeeting() {
    navigate('/add_meeting')
  }

  return (
    <div className="darktheme_card-dv relative self-stretch rounded-lg lightdoc-tabel-head-dv box-border overflow-hidden flex flex-col items-start justify-center  px-0 pb-0  max-w-full text-xl text-surface-bg-primary border-[1px] border-solid border-surface-border">
      <div className="flex py-[15px] gap-[16px] w-full relative">
        <div className="flex gap-[16px] w-full justify-between px-4 items-center">
          {/* <span className="pb-1 text-center font-bold text-base text-black dark:text-white">{currentDate}</span> */}
          <span className="pb-1 text-center font-bold text-xl-dv text-black dark:text-white">
            Today’s Meetings
          </span>

          <div className=" cursor-pointer flex flex-col items-start justify-start p-[10px] plus-task-btn taskdash-plush-img rounded ">
            <img
              className="w-4 h-4 relative overflow-hidden shrink-0 cursor-pointer"
              loading="lazy"
              alt=""
              src={ioniconaaddoutline}
              onClick={handleAddMeeting}
            />
          </div>
        </div>
      </div>

      <div className=" meetingcard_dashborad-box  self-stretch bg-surface-bg-primary grid  items-start justify-start p-3 text-sm text-colors-text-black lightdark_card_blg">
        {/* <div className="self-stretch flex flex-row items-start justify-start pt-0 px-0 pb-[7.5px] gap-[16px]">
          <b className="flex-1 relative font-bold text-base">Meetings</b>
         
        </div> */}
        {(loading || deleteloading) ? (
          <div className="w-full">
            <SkeletonLoader count={3} height="h-24" className="mb-4" />
          </div>
        ) : getMeetings?.length > 0 ? (
          <>
            {currentPage == 1 && new Date(getMeetings[0]?.start_datetime) > now ? (
              <>
                {(() => {
                  // ✅ Prepare meeting data for the first card
                  const firstMeeting = getMeetings[0];
                  const meetingMembers = [
                    ...(firstMeeting?.members || []),
                    ...(firstMeeting?.external_members || []),
                  ];
                  const meetingMembersLength = meetingMembers.length;

                  return (
                    <div className="w-full self-stretch rounded-lg  shrink-0 flex flex-row items-start justify-start min-w-full bg-table-background dark-light-card-calmet">
                      <div className="cal-innerbox mt-[-7px] rounded-tl-none rounded-bl-none flex flex-row items-start justify-start py-[15px] px-2 box-border gap-[8px] shrink-0 [debug_commit:69da668] min-w-full">
                        <div className="relative rounded-tl-none rounded-tr-81xl rounded-br-81xl rounded-bl-none bg-table-background hidden" />
                        <div className="min-w-full relative inline-block shrink-0 gap-[4px] grid">
                          <div className="w-full relative grid shrink-0 gap-[8px]">
                            <div className="w-full flex justify-between">
                              <div className="flex flex-1">
                                <b
                                  className="self-stretch relative truncate overflow-hidden whitespace-nowrap meeting_namehead-dv capitalize"
                                  title={getMeetings[0]?.title} // Optional tooltip to show the full title on hover
                                >
                                  {getMeetings[0]?.title}
                                </b>
                              </div>
                              <div className="flex flex-1 text-right justify-end">
                                <b className="self-stretch relative font-bold text-black whitespace-nowrap text-right">
                                  {format(
                                    new Date(getMeetings[0].start_datetime),
                                    "hh:mm a"
                                  )}
                                </b>
                              </div>
                            </div>
                            <div className="flex justify-between w-full gap-[9px]">
                              <div className="flex items-center">
                                {`Call with`}
                                <div className="col-sm-auto">
                                  <div className="avatar-group">
                                    <div className="self-stretch flex flex-row items-start justify-start gap-2">
                                      {/* Wrapper for hover tooltip */}
                                      <div className="relative group">
                                        <p className="relative font-semibold text-gray dark:text-white my-0 cursor-pointer">
                                          {meetingMembersLength}
                                        </p>

                                        {/* Tooltip */}
                                        <div className="absolute top-[-37px] left-[16px] hidden group-hover:block bg-white shadow-lg rounded-lg p-2 w-48  meeting_member_popup">
                                          <ul className="text-sm text-gray-700 max-h-40 overflow-y-auto ml-0 pl-0">
                                            {meetingMembers?.map((member: any, i: number) => (
                                              <li
                                                key={i}
                                                className="py-1 px-1 hover:bg-gray-100 rounded"
                                              >
                                                {member?.member_name || member?.name || `Member ${i + 1}`}
                                              </li>
                                            ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="self-stretch flex flex-row items-center justify-start py-0 pr-0 mt-[-3px] text-xs text-main-blue">
                                {/* {employeeId ==
                              getMeetings[0]?.host?.employee_id && ( */}
                                <div className="flex flex-1 justify-end">
                                  <div className="gap-[8px] flex">
                                    <div
                                      className="invoicehistory-img relative cursor-pointer"
                                      onClick={() =>
                                        handleEditMeeting(
                                          getMeetings[0]?.id,
                                          getMeetings[0]?.start_datetime,
                                          getMeetings[0]?.end_datetime
                                          // getMeetings[0]?.start_date
                                        )
                                      }
                                    >

                                      <img
                                        className="h-4 w-4 relative overflow-hidden shrink-0 cursor-pointer"
                                        alt=""
                                        src={viewMeeting}
                                        onClick={() =>
                                          handleEditMeeting(
                                            getMeetings[0]?.id,
                                            getMeetings[0]?.start_datetime,
                                            getMeetings[0]?.end_datetime
                                          )
                                        }
                                      />
                                      <span className="absolute download-tooltip">
                                        View Meeting
                                      </span>
                                    </div>
                                    {/* <div
                                  className="invoicehistory-img relative delete-tooltipdash-dv cursor-pointer"
                                  onClick={() =>
                                    handleDeletePopUp(
                                      getMeetings[0]?.id
                                    )
                                  }
                                >
                                  <img
                                    className="h-4 w-4 relative overflow-hidden shrink-0 cursor-pointer"
                                    alt=""
                                    src={icon1}
                                    onClick={() =>
                                      handleDeletePopUp(
                                        getMeetings[0]?.id
                                      )
                                    }
                                  />
                                  <span className="absolute download-tooltip ">
                                    Delete
                                  </span>
                                </div> */}
                                  </div>
                                </div>
                                {/* )} */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })()}
                {isDeletePopupOpen && (
                  <DeleteMeeting
                    onsubmit={deleteMeetingFunction}
                    isOpen={isDeletePopupOpen}
                    onClose={closeDeletePopup}
                    date={currentDate}
                    isDelete={true}
                  />
                )}

                {getMeetings?.slice(1)?.map((meeting: any) => {
                  const meetingTime = new Date(meeting?.end_datetime);
                  const meetingStartTime = new Date(meeting?.start_datetime);
                  const upcomingStatus = meetingTime > now
                  const formattedMeetingTime = format(meetingStartTime, "hh:mm a");
                  const meetingMembers = [
                    ...(meeting?.members || []),
                    ...(meeting?.external_members || []),
                  ];

                  const meetingMembersLength = meetingMembers.length;

                  return (
                    <div
                      key={meeting?.id}
                      className="past_meeting_card self-stretch flex flex-col items-start justify-start mt-[10px]"
                    >
                      <div className="self-stretch flex flex-row items-start justify-start gap-[9px]">
                        {/* <div className=" rounded-81xl flex flex-row items-start justify-start box-border">
                          <img
                            className={`h-8 w-8 relative overflow-hidden shrink-0 ${upcomingStatus == false
                              ? "opacity-[0.4]"
                              : ""
                              }`}
                            alt=""
                            src={ioniconttimeoutline}
                          />
                        </div> */}
                        <div
                          className={`w-full relative grid shrink-0 gap-[8px] ${upcomingStatus == false
                            ? "opacity-[0.4]"
                            : ""
                            }`}
                        >
                          <div className="flex relative justify-between w-full gap-[6px]">
                            <div className="flex">
                              <b
                                className="self-stretch relative truncate overflow-hidden whitespace-nowrap max-w-[200px] capitalize"
                                title={meeting?.title} // Optional tooltip to show the full title on hover
                              >
                                {meeting?.title}
                              </b>
                            </div>
                            <div className="flex absolute right-[0px]">
                              <b className="relative text-black font-semibold whitespace-nowrap capitalize">
                                {formattedMeetingTime}
                              </b>
                            </div>
                          </div>
                          {/* {`Call with ${formattedNames}`} */}
                          <div className="flex justify-between w-full gap-[9px]">
                            <div className="flex items-center">
                              {`Call with:`}
                              <div className="col-sm-auto">
                                <div className="avatar-group">
                                  <div className="self-stretch flex flex-row items-start justify-start gap-2">
                                    {/* Wrapper for hover tooltip */}
                                    <div className="relative group">
                                      <p className="relative font-semibold text-gray dark:text-white my-0 cursor-pointer">
                                        {meetingMembersLength}
                                      </p>

                                      {/* Tooltip */}
                                      <div className="absolute top-[-37px] left-[16px] hidden group-hover:block bg-white shadow-lg rounded-lg p-2 w-48  meeting_member_popup">
                                        <ul className="text-sm text-gray-700 max-h-40 overflow-y-auto ml-0 pl-0">
                                          {meetingMembers?.map((member: any, i: number) => (
                                            <li
                                              key={i}
                                              className="py-1 px-1 hover:bg-gray-100 rounded"
                                            >
                                              {member?.member_name || `Member ${i + 1}`}
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="self-stretch flex flex-row items-center justify-start py-0 pr-0 mt-[-3px] text-xs text-blck">
                              {meeting?.host?.employee_id == employeeId && (
                                <div className="gap-[8px] flex flex-1 justify-end">
                                  {/* {upcomingStatus == true && ( */}
                                  <div
                                    className="invoicehistory-img relative right-[0px] cursor-pointer"
                                    onClick={() =>
                                      handleEditMeeting(
                                        meeting?.id,
                                        meeting?.start_datetime,
                                        meeting?.end_datetime
                                      )
                                    }
                                  >
                                    <img
                                      className="h-4 w-4 relative overflow-hidden shrink-0 cursor-pointer"
                                      alt=""
                                      src={viewMeeting}
                                      onClick={() =>
                                        handleEditMeeting(
                                          meeting?.id,
                                          meeting?.start_datetime,
                                          meeting?.end_datetime
                                        )
                                      }
                                    />
                                    <span className="absolute download-tooltip">
                                      View Meeting
                                    </span>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div >
                  );
                })}
              </>
            ) : (
              <>
                {isDeletePopupOpen && (
                  <DeleteMeeting
                    onsubmit={deleteMeetingFunction}
                    isOpen={isDeletePopupOpen}
                    onClose={closeDeletePopup}
                    date={currentDate}
                    isDelete={true}
                  />
                )}
                {/* <div className="self-stretch h-px relative box-border border-t-[1px] border-solid border-surface-border" /> */}
                {getMeetings?.map((meeting: any) => {
                  const meetingTime = new Date(meeting?.end_datetime);
                  const meetingStartTime = new Date(meeting?.start_datetime);
                  const upcomingStatus = meetingTime > now
                  const formattedMeetingTime = format(meetingStartTime, "hh:mm a");
                  const meetingMembers = [
                    ...(meeting?.members || []),
                    ...(meeting?.external_members || []),
                  ];

                  const meetingMembersLength = meetingMembers.length;

                  return (
                    <>
                      <div
                        key={meeting?.id}
                        className="past_meeting_card self-stretch flex flex-col items-start justify-start mt-[10px]"
                      >
                        <div className="self-stretch flex flex-row items-start justify-start gap-[9px]">
                          <div
                            className={`w-full relative grid shrink-0 gap-[8px] ${upcomingStatus == false
                              ? "opacity-[0.4]"
                              : ""
                              }`}
                          >
                            <div className="flex relative justify-between gap-[6px]">
                              <div className="flex">
                                <b
                                  className="self-stretch relative truncate overflow-hidden whitespace-nowrap max-w-[200px] capitalize"
                                  title={meeting?.title} // Optional tooltip to show the full title on hover
                                >
                                  {meeting?.title}
                                </b>
                              </div>
                              <div className="flex absolute right-[0px]">
                                <b className="relative text-black font-semibold whitespace-nowrap capitalize">
                                  {formattedMeetingTime}
                                </b>
                              </div>
                            </div>
                            {/* {`Call with ${formattedNames}`} */}
                            <div className="flex justify-between w-full gap-[9px]">
                              <div className="flex items-center">

                                {`Call with:`}
                                <div className="col-sm-auto">
                                  <div className="avatar-group">
                                    <div className="self-stretch flex flex-row items-start justify-start gap-2">
                                      {/* Wrapper for hover tooltip */}
                                      <div className="relative group">
                                        <p className="relative font-semibold text-gray dark:text-white my-0 cursor-pointer">
                                          {meetingMembersLength}
                                        </p>

                                        {/* Tooltip */}
                                        <div className="absolute top-[-37px] left-[16px] hidden group-hover:block bg-white shadow-lg rounded-lg p-2 w-48  meeting_member_popup">
                                          <ul className="text-sm text-gray-700 max-h-40 overflow-y-auto ml-0 pl-0">
                                            {meetingMembers?.map((member: any, i: number) => (
                                              <li
                                                key={i}
                                                className="py-1 px-2 hover:bg-gray-100 rounded dark:text-white"
                                              >
                                                {member?.member_name || `Member ${i + 1}`}
                                              </li>
                                            ))}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="self-stretch flex flex-row items-center justify-start py-0 pr-0 mt-[-3px] text-xs text-blck">
                                <div className="gap-[8px] flex flex-1 justify-end">
                                  <>
                                    <div
                                      className="invoicehistory-img relative right-[0px] cursor-pointer"
                                      onClick={() =>
                                        handleEditMeeting(
                                          meeting?.id,
                                          meeting?.start_datetime,
                                          meeting?.end_datetime
                                        )
                                      }
                                    >
                                      <img
                                        className="h-4 w-4 relative overflow-hidden shrink-0 cursor-pointer"
                                        alt=""
                                        src={viewMeeting}
                                        onClick={() =>
                                          handleEditMeeting(
                                            meeting?.id,
                                            meeting?.start_datetime,
                                            meeting?.end_datetime
                                          )
                                        }
                                      />
                                      <span className="absolute download-tooltip">
                                        View Meeting
                                      </span>
                                    </div>
                                  </>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  );
                })}
              </>
            )}
          </>
        ) : (
          <div className="w-[262px] h-[323px] self-stretch rounded-lg bg-surface-bg-secondary overflow-hidden flex flex-col dark:bg-slate-700 items-center justify-center py-[23.5px] px-5 gap-[8px] whitespace-nowrap text-center text-base text-text-text-secondary">
            <img
              className="w-9 h-9 relative overflow-hidden shrink-0 dark-white-img"
              loading="lazy"
              alt=""
              src={ioniconvvideocamoutline1}
            />
            <p className="relative my-0 inline-block min-w-[126px] dark:text-white">
              No Meetings Yet
            </p>
          </div>
        )}

        {/* Pagination Section */}
        {/* {meetingsbyDate?.get_meetings?.pagination?.total_items >
          3 && (
          <div className="self-stretch flex flex-col items-end justify-start">
            <div className="flex flex-row items-center justify-end gap-[4px] mt-4">
              {Array.from({ length: totalPages }, (_, index) => (
                <div
                  key={index}
                  className={`h-1.5 w-1.5 relative rounded-81xl ${
                    currentPage === index + 1
                      ? "bg-colors-text-black"
                      : "bg-surface-border"
                  } cursor-pointer`}
                  onClick={() => handlePageChange(index + 1)}
                />
              ))}
            </div>
          </div>
        )} */}
      </div >
    </div >
  );
};

export default Meetings;
